import { reviewList } from "@/mocks/anime";

export default function Reviews() {
  return (
    <section id="reviews" className="bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-primary-600 font-bold text-sm">
            <i className="ri-chat-smile-fill text-lg"></i>
            用户口碑
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-900">
            上万追番人亲测：真的笑出声
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            干饭人、打工人、追番重症患者的真实评价，小狗看番专治不开心。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {reviewList.map((rv) => (
            <figure
              key={rv.id}
              className="bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 text-secondary-500">
                {Array.from({ length: rv.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-lg"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm md:text-base text-foreground-700 leading-relaxed">
                “{rv.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <img
                  src={rv.avatar}
                  alt={`${rv.name} 的头像`}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <div className="font-bold text-foreground-900 text-sm">{rv.name}</div>
                  <div className="text-xs text-foreground-500">{rv.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}